<template>
  <section>
    <scroll-container
      class="pt-2 mt-n30px"
      :height-offset="isInEditMode ? '55px' : '125px'"
    >
      <b-row v-if="loading">
        <b-col
          sm="12"
          class="text-center"
        >
          <b-skeleton
            class="d-inline-block"
            animation="wave"
            width="40%"
            height="100px"
          />
        </b-col>
      </b-row>
      <b-container
        v-else
        class="container-small"
      >
        <b-card class="mb-2">
          <div class="mb-2">
            <b-card-title
              v-if="model.nativeAdModel.adId === 0"
              class="mb-0"
            >
              {{ $tk('ClientPortal.Form.NewNativeAd') }}
            </b-card-title>
            <b-card-title
              v-else
              class="mb-0"
            >
              {{ $tk('ClientPortal.Form.EditNativeAd') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/edit/${model.campaignModel.id}`">
                {{ model.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/edit?adGroupId=${model.adGroup.id}&campaignId=${model.campaignModel.id}`">
                {{ model.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-if="model.nativeAdModel.adId ===0"
                active
              >
                {{ $tk('ClientPortal.Form.NewAd') }}
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-else
                active
              >
                <!-- <GjIcon name="Desktop" /> -->
                {{ model.nativeAdModel.name }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <b-form-row v-if="model.adGroup.adSubtypeId == 6 && model.catalogs.length > 0 && !model.nativeAdModel.adId > 0">
            <b-col
              sm="6"
            >
              <b-button
                variant="outline-dark"
                :class="{'text-primary btn-outline-primary' : type == 1}"
                class="d-flex justify-content-between align-items-center mb-50 mb-sm-0"
                block
                @click="resetToManualProduct(1)"
              >
                {{ $tk('ClientPortal.Form.ManualProduct') }}
                <b-form-radio
                  v-model="type"
                  class="radio-btn"
                  value="1"
                />
              </b-button>
            </b-col>
            <b-col
              sm="6"
            >
              <b-button
                variant="outline-dark"
                :class="{'text-primary btn-outline-primary' : type == 2}"
                class="d-flex justify-content-between align-items-center"
                block
                @click="type = 2"
              >
                {{ $tk('ClientPortal.Form.CatalogProduct') }}
                <b-form-radio
                  v-model="type"
                  class="radio-btn"
                  value="2"
                />
              </b-button>
            </b-col>
          </b-form-row>
          <template v-if="type == 1 || model.nativeAdModel.adId > 0">
            <b-form-group
              class="my-2"
              :label="$tk('ClientPortal.Form.AdName') + ' *'"
              :invalid-feedback="errors['Name']"
              :state="errors['Name'] == null ? null : false"
            >
              <AdNameField
                id="Name"
                v-model="model.nativeAdModel.name"
                :variables="adNameVariables"
                :state="errors['Name'] == null ? null : false"
                :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
              />
            </b-form-group>
            <b-card-title class="mb-25">
              {{ $tk('ClientPortal.Form.Info') }}
            </b-card-title>
            <b-card-text class="mb-2">
              {{ $tk('ClientPortal.Form.Info.Description') }}
            </b-card-text>

            <template v-if="model.nativeAdModel.catalogSetId && model.nativeAdModel.catalogSetId > 0">
              <b-form-group
                class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Info.Catalog') }}
                  <GjIcon name="Info" />
                </legend>
                <v-select
                  :value="model.catalogSet.catalogName"
                  :clearable="false"
                  label="name"
                  :disabled="true"
                />
              </b-form-group>

              <b-form-group
                class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Info.CatalogSet') }}
                  <GjIcon name="Info" />
                </legend>
                <v-select
                  :value="model.catalogSet.name"
                  :clearable="false"
                  label="name"
                  :disabled="true"
                />
              </b-form-group>
            </template>

            <template v-if="model.nativeAdModel.catalogItemId > 0">
              <b-form-group
                class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Product') }} *
                  <GjIcon name="Info" />
                </legend>
                <div class="d-flex">
                  <b-avatar
                    :src="getProductImage()"
                    variant="light"
                    size="3rem"
                  />
                  <label
                    v-if="model.nativeAdModel.customProperties && model.nativeAdModel.customProperties.length > 0"
                    class="mb-0 pt-1"
                  >
                    {{ model.nativeAdModel.customProperties[0].value }}
                  </label>
                </div>
              </b-form-group>
            </template>

            <template v-for="(input, index) in model.nativeAdModel.customProperties.filter(x => x.id !== 17 && x.id !== 16)">
              <b-form-group
                v-if="input.inputType == 1 && model.nativeAdModel.catalogItemId == null && model.nativeAdModel.catalogSetId == null"
                :id="input.name"
                :key="index"
                class="mb-2"
                :invalid-feedback="errors[input.name]"
                :state="errors[input.name] == null ? null : false"
              >
                <legend class="col-form-label pt-0">
                  <b-form-row>
                    <b-col>
                      {{ input.displayName }} <span v-if="input.required == true">*</span>
                    </b-col>
                    <b-col class="pt-25 text-right">
                      <b-card-text class="text-muted">
                        {{ input.value.length }}/{{ input.maxLength }}
                      </b-card-text>
                    </b-col>
                  </b-form-row>
                </legend>
                <b-form-input
                  :id="input.name"
                  v-model="input.value"
                  :placeholder="$tk('ClientPortal.Form.Enter') + input.displayName.toLowerCase() + $tk('ClientPortal.Form.Here')"
                  type="text"
                  :maxlength="input.maxLength"
                  :state="errors[input.name] == null ? null : false"
                />
              </b-form-group>
            </template>
            <b-form-row>
              <template v-for="(input, index) in model.nativeAdModel.customProperties.filter(x => x.id === 17 || x.id === 16)">
                <b-col :key="index">
                  <b-form-group
                    v-if="input.inputType == 1 && model.nativeAdModel.catalogItemId == null && model.nativeAdModel.catalogSetId == null"
                    :id="input.name"
                    class="mb-2"
                    :invalid-feedback="errors[input.name]"
                    :state="errors[input.name] == null ? null : false"
                  >
                    <legend class="col-form-label pt-0">
                      <b-form-row>
                        <b-col>
                          {{ input.displayName }} <span v-if="input.required == true">*</span>
                        </b-col>
                      </b-form-row>
                    </legend>
                    <b-form-input
                      :id="input.name"
                      v-model="input.value"
                      type="text"
                      :maxlength="input.maxLength"
                      :state="errors[input.name] == null ? null : false"
                    />
                  </b-form-group>
                </b-col>
              </template>
            </b-form-row>
            <b-form-group
              id="Url"
              class="mb-2"
              :invalid-feedback="errors['Url']"
              :state="errors['Url'] == null ? null : false"
            >
              <legend class="col-form-label pt-0">
                {{ $tk('ClientPortal.Form.Url') }} *
                <GjIcon
                  v-b-tooltip.hover="$tk('ClientPortal.Form.URLTooltip')"
                  name="Info"
                />
              </legend>
              <b-form-input
                v-model="model.nativeAdModel.url"
                type="text"
                :disabled="(model.nativeAdModel.catalogItemId && model.nativeAdModel.catalogItemId > 0) ||
                  (model.nativeAdModel.catalogSetId && model.nativeAdModel.catalogSetId > 0)"
                placeholder="https://www.example.com/page"
                :state="errors['Url'] == null ? null : false"
              />
            </b-form-group>
            <b-button
              v-b-toggle.url-builder
              class="bg-white mb-2"
              size="sm"
              variant="outline-primary"
            >
              <GjIcon
                class="mr-50"
                name="Hyperlink"
              />
              <span class="when-open">
                {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
                <GjIcon
                  class="mr-50"
                  name="ArrowUp"
                />
              </span>
              <span class="when-closed">
                {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
                <GjIcon
                  class="mr-50"
                  name="ArrowDown"
                />
              </span>
            </b-button>
            <b-collapse
              id="url-builder"
            >
              <url-builder
                :ref="'utm-'+model.nativeAdModel.id"
                :key="model.nativeAdModel.id"
                v-model="model.nativeAdModel.url"
                :options="model.utmOptions"
                :is-product-ad="(model.nativeAdModel.catalogItemId && model.nativeAdModel.catalogItemId > 0) || model.nativeAdModel.catalogSetId > 0"
              />
            </b-collapse>
            <b-form-group
              class="mb-2"
            >
              <legend class="col-form-label pt-0">
                {{ $tk('ClientPortal.Form.ImpressionTag') }}
                <GjIcon
                  v-b-tooltip.hover="$tk('ClientPortal.Form.ImpressionTagTooltip')"
                  name="Info"
                />
              </legend>
              <b-form-textarea
                v-model="model.nativeAdModel.impressionTag"
                type="text"
                :placeholder="$tk('ClientPortal.Form.ImpressionTagPlaceholder')"
                rows="3"
              />
            </b-form-group>

            <template v-for="(input, inputIndex) in model.nativeAdModel.customProperties">
              <b-form-group
                v-if="input.inputType == 2 && model.nativeAdModel.catalogItemId == null && model.nativeAdModel.catalogSetId == null"
                :key="inputIndex"
                class="mb-2"
                :label="input.displayName + '*'"
              >
                <vue-dropzone
                  id="dropzone"
                  :ref="'nativeAdDropzone-'+ inputIndex"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  @vdropzone-success="uploadFile"
                  @vdropzone-processing="dropzoneChangeUrl(inputIndex)"
                  @vdropzone-thumbnail="checkFileThumbnail(inputIndex)"
                  @vdropzone-complete="removeFile($event, inputIndex)"
                >
                  <div class="dz-default dz-message dz-message-center mx-3">
                    <span class="d-block mb-3 line-height-1">
                      {{ $tk('ClientPortal.Form.UploadImageWithDimensions') }}
                    </span>
                    <b-button
                      variant="outline-primary"
                      class="mr-2"
                      size="sm"
                    >
                      <GjIcon
                        class="mr-50"
                        name="Hyperlink"
                      />
                      {{ $tk('ClientPortal.Form.UploadFiles') }}
                    </b-button>
                  </div>
                </vue-dropzone>
                <span
                  v-if="uploadMessage && inputIndex == index"
                  class="text-success small"
                >
                  {{ uploadMessage }}
                </span>
                <span
                  v-if="errors[input.name]"
                  class="field-validation-valid text-danger small"
                >
                  {{ errors[input.name] }}
                </span>
                <input
                  :id="input.name"
                  v-model="input.value"
                  type="hidden"
                  :name="'PropertyValues.' + input.name"
                  class="col-sm-8"
                >
              </b-form-group>
            </template>
            <b-row
              v-if="model.nativeAdModel.catalogItemId == null && model.nativeAdModel.customProperties.filter(x => x.inputType == 3).length > 0"
              class="mb-2"
            >
              <b-col sm="8">
                <b-card-text class="mb-50">
                  {{ $tk('ClientPortal.Form.CustomizeColors') }}
                </b-card-text>
              </b-col>
              <b-col
                sm="4"
                class="text-right"
              >
                <input
                  v-model="customizeColors"
                  type="hidden"
                  name="customizeColors"
                >
                <b-form-checkbox
                  v-model="customizeColors"
                  class="d-block"
                  checked="false"
                  name="check-button"
                  switch
                />
              </b-col>
            </b-row>
            <b-row
              v-if="customizeColors && model.nativeAdModel.catalogItemId == null"
              class="mt-2 mb-n2"
            >
              <template
                v-for="(input, inputIndex) in model.nativeAdModel.customProperties"
              >
                <b-col
                  v-if="input.inputType == 3"
                  :key="inputIndex"
                  sm="6"
                >
                  <b-form-group
                    :label="input.displayName"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <v-swatches
                          :id="input.name"
                          v-model="input.value"
                          show-fallback
                          :value="input.value"
                          show-border
                          popover-to="right"
                        />
                      </b-input-group-prepend>
                      <v-swatches
                        :id="input.name"
                        v-model="input.value"
                        show-fallback
                        :value="input.value"
                        show-border
                        popover-to="right"
                      >
                        <input
                          slot="trigger"
                          :value="input.value"
                          class="form__input__element"
                          readonly
                        >
                      </v-swatches>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
          </template>
          <!--Template two-->
          <template
            v-else-if="type == 2"
            id="template2"
          >
            <b-form-group
              class="mt-2 mb-0"
              label="Choose Catalog"
            >
              <v-select
                v-model="selectedCatalog"
                :clearable="false"
                label="name"
                class="smaller-indicator"
                :placeholder="$tk('ClientPortal.NativeAd.ChoseCatalog')"
                :options="model.catalogs"
                :get-option-key="catalog => catalog.encodedId"
                @option:selected="resetCatalogType()"
              />
            </b-form-group>
            <b-form-group
              v-if="selectedCatalog"
              class="mt-2 mb-0"
              :label="$tk('ClientPortal.Form.ChooseType')"
            >
              <b-form-row>
                <b-col sm="6">
                  <b-button
                    variant="outline-dark"
                    :class="{'text-primary btn-outline-primary' : model.nativeAdModel.catalogProductType == 1}"
                    class="d-flex justify-content-between align-items-center mb-50 mb-sm-0"
                    block
                    @click.prevent="openItemModal(selectedCatalog)"
                  >
                    {{ $tk('ClientPortal.Form.SelectItemsManually') }}
                    <b-form-radio
                      v-model="model.nativeAdModel.catalogProductType"
                      value="1"
                      class="radio-btn"
                    />
                  </b-button>
                </b-col>
                <b-col
                  v-if="configuration.clientConfiguration.showCatalogSet"
                  sm="6"
                >
                  <b-button
                    variant="outline-dark"
                    :class="{'text-primary btn-outline-primary' : model.nativeAdModel.catalogProductType == 2}"
                    class="d-flex justify-content-between align-items-center"
                    block
                    @click="setCatalogProductType(2)"
                  >
                    {{ $tk('ClientPortal.Form.UseFilters') }}
                    <b-form-radio
                      v-model="model.nativeAdModel.catalogProductType"
                      value="2"
                      class="radio-btn"
                    />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-form-group>
            <b-form-group
              v-if="model.nativeAdModel.catalogProductType == 2"
              id="CatalogSetId"
              class="mt-2 mb-0"
              :label="$tk('ClientPortal.Form.ChooseCatalogSet')"
              :invalid-feedback="catalogSet.errors['CatalogSetId']"
              :state="catalogSet.errors['CatalogSetId'] == null ? null : false"
            >
              <b-form-row>
                <b-col :sm="canAccountCreateSet(selectedCatalog.accountId) ? 11 : 12">
                  <b-form-group
                    :state="catalogSet.errors['CatalogSetId'] == null ? null : false"
                  >
                    <v-select
                      v-model="model.nativeAdModel.catalogSetId"
                      :clearable="false"
                      label="name"
                      class="custom-b-selkect"
                      :options="catalogSets"
                      :placeholder="$tk('ClientPortal.Form.ChooseCatalogSet')"
                      :reduce="set => set.id"
                      @input="selectedCatalogSet()"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="canAccountCreateSet(selectedCatalog.accountId)"
                  class="pt-50 text-center"
                  sm="1"
                >
                  <b-link
                    variant="link"
                    :to="redirectToCatalogSetCreate(selectedCatalog)"
                  >
                    <GjIcon
                      name="Plus"
                    />
                  </b-link>
                </b-col>
              </b-form-row>
              <b-skeleton
                v-if="loadingCatalogSetItemsCount"
                animation="wave"
                width="45%"
                height="15px"
                class="my-25"
              />
              <template
                v-if="!loadingCatalogSetItemsCount && model.nativeAdModel.catalogSetId > 0"
                #description
              >
                This catalog set contains {{ catalogSet.itemsCount }} items.
              </template>
            </b-form-group>
            <template v-if="model.nativeAdModel.catalogSetId > 0">
              <b-form-group
                id="Name"
                class="mt-2 mb-0"
                :label="$tk('ClientPortal.Form.AdName') + ' *'"
                :invalid-feedback="catalogSet.errors['Name']"
                :state="catalogSet.errors['Name'] == null ? null : false"
              >
                <b-form-input
                  v-model="catalogSet.name"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.NamePlaceHolder')"
                  :state="catalogSet.errors['Name'] == null ? null : false"
                />
              </b-form-group>
            </template>
          </template>
        </b-card>
        <!--ADS-->
        <!--TODO: Change design-->
        <b-card
          v-for="(catalogProduct,catalogProductIndex) in model.catalogProducts"
          :key="catalogProductIndex"
          class="mb-2"
        >
          <div class="position-relative bg-light border rounded-sm mb-2">
            <div
              class="products-img"
              :style="{ backgroundImage: 'url(' + catalogProduct.imageUrl + ')' }"
            />
            <div class="position-absolute bg-white rounded-sm top-50 right-50 p-25">
              <b-button
                class="px-0"
                size="sm"
                variant="link"
                @click="removeCatalogProductAd(catalogProductIndex)"
              >
                <GjIcon
                  class="text-secondary"
                  name="Delete"
                />
              </b-button>
            </div>
          </div>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName')"
            :invalid-feedback="catalogProduct.errors['Name']"
          >
            <b-form-input
              id="Name"
              v-model="catalogProduct.name"
              type="text"
              name="name"
              :state="catalogProduct.errors['Name'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.Url')"
            :invalid-feedback="catalogProduct.errors['Url']"
          >
            <b-form-input
              id="Url"
              v-model="catalogProduct.url"
              type="text"
              name="url"
              :state="catalogProduct.errors['Url'] == null ? null : false"
              disabled
            />
          </b-form-group>
          <b-button
            v-b-toggle="'url-builder-'+catalogProductIndex"
            class="bg-white mb-2"
            size="sm"
            variant="outline-primary"
          >
            <GjIcon
              class="mr-50"
              name="Hyperlink"
            />
            <span class="when-open">
              {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowUp"
              />
            </span>
            <span class="when-closed">
              {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowDown"
              />
            </span>
          </b-button>
          <b-collapse
            :id="'url-builder-'+catalogProductIndex"
          >
            <url-builder
              :ref="'utm'+catalogProductIndex"
              :key="catalogProductIndex"
              v-model="catalogProduct.url"
              :options="model.utmOptions"
              :is-product-ad="true"
            />
          </b-collapse>
          <b-form-group
            class="mb-0"
            :label="$tk('ClientPortal.Form.ImpressionTag')"
          >
            <b-form-input
              v-model="catalogProduct.impressionTag"
              type="text"
              name="impression-tag"
            />
          </b-form-group>
        </b-card>
        <!--Ad Preview-->
        <template v-if="type == 1 || model.nativeAdModel.adId >0">
          <b-card
            v-if="model.nativeAdModel.catalogSetId == null"
            no-body
            class="mb-3"
            @click="showPreview(preview)"
          >
            <b-card-title
              v-b-toggle.collapse-ad-preview
              class="d-flex justify-content-between p-2 mb-0"
            >
              <div
                class="text-primary"
              >
                <GjIcon name="Show" />
                {{ $tk('ClientPortal.Form.AdCreation.AdPreview') }}
              </div>
              <span class="when-open">
                <GjIcon name="ArrowUp" />
              </span>
              <span class="when-closed">
                <GjIcon name="ArrowDown" />
              </span>
            </b-card-title>
            <b-collapse
              id="collapse-ad-preview"
            >
              <b-card-body class="pt-0">
                <hr class="mt-0">
                <b-tabs
                  show="preview"
                  fill
                >
                  <b-tab
                    active
                  >
                    <template #title>
                      <GjIcon
                        class="mr-50"
                        name="Desktop"
                      />
                      {{ $tk('ClientPortal.Form.AdPreview.Desktop') }}
                    </template>
                    <div
                      style="position:relative;"
                      :style="{height: model.nativeAdModel.height + 'px' }"
                    >
                      <a
                        :href="model.nativeAdModel.url"
                        target="_blank"
                      >
                        <div
                          class="text-center"
                          :style="{ height: model.nativeAdModel.height + 'px' }"
                        >
                          <iframe
                            id="preview-frame"
                            ref="previewFrameDesktop"
                            class="desktop"
                            style="max-width:600px; border:0px; pointer-events:none;"
                            :style="{ width: (model.nativeAdModel.width == 0 ? '100%' : model.nativeAdModel.width + 'px'),
                                      height: (model.nativeAdModel.height == 0 ? '100%' : model.nativeAdModel.height + 'px')}"
                          />
                        </div>
                      </a>
                    </div>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <GjIcon
                        class="mr-50"
                        name="Mobile"
                      />
                      {{ $tk('ClientPortal.Form.AdPreview.Mobile') }}
                    </template>
                    <div
                      class="d-flex justify-content-center"
                      :style="{height: model.nativeAdModel.height + 'px'}"
                    >
                      <a
                        :href="model.nativeAdModel.url"
                        target="_blank"
                      >
                        <div
                          class="text-center"
                          :style="{height: model.nativeAdModel.height + 'px'}"
                        >
                          <iframe
                            id="preview-frame-mobile"
                            ref="previewFrameMobile"
                            style="width:100%; border:0px; pointer-events:none;"
                            :style="{ height: (model.nativeAdModel.height == 0 ? '100%' : model.nativeAdModel.height + 'px') }"
                          />
                        </div>
                      </a>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>
      </b-container>
    </scroll-container>

    <div class="border-top text-right py-1">
      <div class="container-small mx-auto">
        <b-button
          v-if="isInEditMode"
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="closeEditModal"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          v-else
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="cancelAd"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="type === endpointType.CATALOG_PRODUCT ? isSaveButtonDisabled() : !isFormComplete"
          @click="saveNativeAd()"
        >
          {{ isInEditMode ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.CreateAd') }}
        </b-button>
      </div>
    </div>
    <b-modal
      id="catalog-item-modal"
      ref="catalog-item-modal"
      body-class="modal-body--no-padding"
      hide-footer
      :title="$tk('ClientPortal.NativeAd.CatalogItems')"
      size="xl"
      centered
    >
      <div class="mx-1 mb-1">
        <b-form-row>
          <b-col
            sm="6"
            class="mb-50 mb-sm-0"
          >
            <b-form-input
              v-model="catalogModel.filter.name"
              type="text"
              :placeholder="$tk('ClientPortal.NativeAd.Search')"
              @input="filterItemsByName"
            />
          </b-col>
          <b-col
            sm="3"
            class="mb-50 mb-sm-0"
          >
            <multiselect
              v-model="catalogModel.filter.brands"
              :placeholder="$tk('ClientPortal.Form.SearchBrands')"
              :option-height="104"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="true"
              :show-labels="false"
              :options="brands"
              :internal-search="false"
              :loading="loadingMultiselect"
              @input="filterItems"
              @focus.stop=""
              @search-change="(name) => loadBrands(name)"
            >
              <template
                slot="caret"
                slot-scope="{ toggle }"
              >
                <div
                  class="multiselect__select"
                  @mousedown.prevent.stop="toggle()"
                >
                  <GjIcon
                    class="icon-wrapper"
                    name="ArrowDown_fill"
                    size="21"
                  />
                </div>
              </template>
            </multiselect>
          </b-col>
          <b-col
            sm="3"
          >
            <multiselect
              v-model="catalogModel.filter.categories"
              :options="categories"
              :placeholder="$tk('ClientPortal.Form.SearchCategories')"
              :option-height="104"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              :show-labels="false"
              input="filterItems"
              :internal-search="false"
              :loading="loadingMultiselect"
              @focus.stop=""
              @search-change="(name) => loadCategories(name)"
            >
              <template
                slot="caret"
                slot-scope="{ toggle }"
              >
                <div
                  class="multiselect__select"
                  @mousedown.prevent.stop="toggle()"
                >
                  <GjIcon
                    class="icon-wrapper"
                    name="ArrowDown_fill"
                    size="21"
                  />
                </div>
              </template>
            </multiselect>
          </b-col>
        </b-form-row>
      </div>
      <hr class="mb-0">

      <scroll-container
        class="pt-1 px-1"
        height-offset="260px"
      >
        <b-row class="mx-n50">
          <b-col
            v-for="item in catalogModel.items"
            :key="item.id"
            xl="2"
            md="3"
            sm="6"
            cols="12"
            class="mb-1 px-50"
          >
            <b-card
              class="mb-0 h-100 border hover-pointer"
              body-class="d-flex flex-direction-column"
              :class="{'border-primary' : item.selected}"
              @click.prevent="selectCatalogProduct(item)"
            >
              <div class="text-right">
                <b-form-checkbox
                  v-model="item.selected"
                  class="d-inline-block pl-1"
                />
              </div>
              <b-card
                class="mb-2"
                body-class="p-0"
              >
                <div
                  class="products-img text-center mx-auto"
                  :style="{ backgroundImage: 'url(' + item.imageUrl + ')' }"
                />
              </b-card>

              <b-card-title class="mb-1">
                {{ item.title }}
              </b-card-title>
              <div class="mt-auto">
                <p class="mb-50">
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.CatalogItem.Id') }}:
                  </span>
                  {{ item.contentId }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.Catalogs.Price') }}:
                  </span>
                  {{ item.price }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.Catalogs.PriceWithDiscount') }}:
                  </span>
                  {{ item.priceWithDiscount }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.CatalogItem.Stock') }}:
                  </span>
                  {{ item.stock }}
                </p>
                <a
                  :href="item.productUrl"
                  target="_blank"
                  class="text-uppercase text-danger font-weight-bold mt-1 mb-0"
                >
                  {{ $tk('ClientPortal.Catalogs.Link') }}
                </a>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <div class="text-center">
          <div v-if="catalogModel.items.length === 0 && !catalogModel.loading">
            {{ $tk('ClientPortal.NativeAd.NoItems') }}
          </div>
          <div v-if="catalogModel.loading">
            <b-spinner
              label="Loading..."
            />
          </div>
          <!-- <loader
            :size="10"
            :show="catalogModel.loading"
            class="d-inline-block ml-2"
          /> -->
          <div
            v-if="!loadedAllItems && !catalogModel.loading"
            class="text-center mb-1"
          >
            <b-button
              variant="primary"
              class="text-center"
              size="sm"
              @click="loadItems()"
            >
              {{ $tk('ClientPortal.NativeAd.LoadMore') }}
            </b-button>
          </div>
        </div>
      </scroll-container>
      <div class="p-1 border-top text-right">
        <b-button
          class=""
          variant="outline-secondary"
          size="sm"
          @click.prevent="hideGallery"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="ml-50"
          variant="primary"
          size="sm"
          @click.prevent="addCatalogProducts()"
        >
          {{ $tk('ClientPortal.Form.Add') }}
        </b-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Multiselect from 'vue-multiselect'
import VSwatches from 'vue-swatches'
import notification from '@/mixins/toastification'
import sweetAlert from '@/mixins/sweetAlert'
import ScrollContainer from '@/components/ScrollContainer.vue'
import UrlBuilder from '@/components/UrlBuilder.vue'
import { mapGetters } from 'vuex'
import getAPIDomain from '@/utils/apiDomain/apiDomain'
import CatalogSetsService from '@/api/client/catalogSets.service'
import AdsService from '@/api/client/ads.service'
import CatalogsService from '@/api/client/catalogs.service'
import 'vue-swatches/dist/vue-swatches.css'
import scrollToError from '@/mixins/scrollToError'
import vSelect from 'vue-select'
import AdNameField from '@/components/AdNameField.vue'
import { AD_NAME_VARIABLES, findUnknownTokens } from '@/utils/adNameTokens'

function debounce(fn, delay) {
  let timeoutID = null
  // eslint-disable-next-line func-names
  return function () {
    clearTimeout(timeoutID)
    // eslint-disable-next-line prefer-rest-params
    const args = arguments
    const that = this
    timeoutID = setTimeout(() => {
      fn.apply(that, args)
    }, delay)
  }
}

const PRODUCT_NATIVE_AD_SUBTYPE = 6
const PRODUCT_NATIVE_AD_FORMAT = 9

const CATALOG_PRODUCT_TYPES = {
  MANUAL: 1,
  SET: 2,
}
export default {
  inject: ['closeEditModal'],
  components: {
    GjIcon,
    vueDropzone: vue2Dropzone,
    Multiselect,
    VSwatches,
    ScrollContainer,
    UrlBuilder,
    vSelect,
    AdNameField,
  },
  mixins: [notification, sweetAlert],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    adId: Number,
    // eslint-disable-next-line vue/require-default-prop
    adGroupId: Number,
    // eslint-disable-next-line vue/require-default-prop
    catalogSetId: {
      type: String,
    },
    saving: {
      type: Boolean,
    },
  },
  data() {
    return {
      model: {},
      type: 0,
      errors: {},
      preview: false,
      customizeColors: false,
      color: '',
      name: '',
      dropzoneOptions: {
        uploadMultiple: false,
        maxFiles: 1,
        acceptedFiles: '.jpg,.png,.jpeg,.gif',
        url: 'url',
        thumbnailWidth: null,
        thumbnailHeight: null,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
      catalogModel: {
        encodedId: '0',
        items: [],
        loading: false,
        filter: {
          name: '',
          brands: [],
          categories: [],
        },
      },
      catalogTypes: {
        PRODUCT: 1,
        VIDEO: 2,
        CHANNEL: 3,
        SERIE: 4,
      },
      endpointType: {
        MANUAL: 1,
        CATALOG_PRODUCT: 2,
      },
      uploadMessage: '',
      brands: [],
      categories: [],
      loadingMultiselect: false,
      loadedAllItems: false,
      searchingCatalogItems: false,
      productInfo: {
        imageUrl: '',
      },
      selectedCatalog: null,
      loadingCatalogSetItemsCount: false,
      catalogSet: {
        errors: {},
      },
      catalogSets: null,
      loading: false,
      index: null,
    }
  },
  computed: {
    isFormComplete() {
      const { nativeAdModel } = this.model
      return nativeAdModel.name && nativeAdModel.url && nativeAdModel.customProperties.every(x => x.value)
    },
    isInEditMode() {
      return this.adId > 0
    },
    adNameVariables() {
      return AD_NAME_VARIABLES.filter(key => key !== 'format')
    },
    ...mapGetters(['configuration']),
  },
  async mounted() {
    this.loading = true
    try {
      this.model = await AdsService.getAd(this.adId, this.adGroupId, this.catalogSetId, this.$route.params.accountId)
    } catch (error) {
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      this.loading = false
    }
    this.initializeNativeCustomProperties()
    this.setNativeType()
    this.autoCompleteNativeAdModel()
  },
  methods: {
    dropzoneChangeUrl(index) {
      this.index = index
      const clientApi = getAPIDomain()
      const { accountId } = this.$route.params

      if (Array.isArray(this.$refs[`nativeAdDropzone-${index}`])) {
        this.$refs[`nativeAdDropzone-${index}`].forEach(x => x.setOption('url', `${clientApi}/upload/ad?accountId=${accountId}`))
      } else {
        this.$refs[`nativeAdDropzone-${index}`].setOption('url', `${clientApi}/upload/ad?accountId=${accountId}`)
      }
    },
    setSaving(value) {
      this.$emit('onUpdate', value)
    },
    validateNativeAdName() {
      const ad = this.model.nativeAdModel
      this.$set(this.errors, 'Name', null)
      const unknown = findUnknownTokens(ad.name)
      if (unknown.length > 0) {
        const tokens = unknown.map(k => `{{${k}}}`).join(', ')
        this.$set(this.errors, 'Name', `Unknown variables: ${tokens}`)
        return false
      }
      return true
    },
    async saveNativeAd() {
      const { nativeAdModel } = this.model
      this.checkCatalogProduct(nativeAdModel)
      let { catalogProductType } = nativeAdModel
      const isInEditMode = nativeAdModel.adId > 0
      if (isInEditMode) {
        catalogProductType = nativeAdModel.catalogSetId !== null ? CATALOG_PRODUCT_TYPES.SET : CATALOG_PRODUCT_TYPES.MANUAL
      }
      const catalogProductsModel = {
        catalogProducts: this.model.catalogProducts,
        catalogSet: this.catalogSet,
        productType: catalogProductType,
      }
      if (this.type === this.endpointType.MANUAL) {
        if (!this.validateNativeAdName()) {
          this.$nextTick(() => scrollToError(this.errors))
          this.setSaving(false)
          return
        }
        try {
          const response = await AdsService.createNativeAd(nativeAdModel, this.$route.params.accountId)
          this.model.nativeAdModel = response.model
          this.errors = response.errors
          if (response.success) {
            if (isInEditMode) {
              const { entity } = this.$parent.$parent.$parent
              entity.name = response.name || response.adName || this.model.nativeAdModel.name
              this.success(response.message)
              this.closeEditModal()
            } else {
              this.sweetAlertAfterAdCreation()
            }
          } else {
            this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            this.$nextTick(() => {
              scrollToError(this.errors)
            })
          }
        } catch (error) {
          this.error(error.message)
        }
        scrollToError(this.errors)
        this.setSaving(true)
      } else {
        if (catalogProductsModel.productType === 0) {
          this.setSaving(false)
          return
        }

        if (CATALOG_PRODUCT_TYPES.SET === catalogProductsModel.productType) {
          try {
            const response = await AdsService.createCatalogSetAd(catalogProductsModel.catalogSet, this.$route.params.accountId)
            this.catalogSet = response.catalogSet
            if (response.success) {
              this.sweetAlertAfterAdCreation()
            } else {
              this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            }
          } catch (error) {
            this.error(error.message)
          }
          this.setSaving(true)
        } else {
          try {
            const response = await AdsService.createCatalogProductAds(catalogProductsModel.catalogProducts, this.$route.params.accountId)
            this.model.catalogProducts = response.catalogProducts
            this.errors = response.errors
            if (response.success) {
              this.sweetAlertAfterAdCreation()
            } else {
              this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
              this.$nextTick(() => {
                scrollToError(this.errors)
              })
            }
          } catch (error) {
            this.error(error.message)
          }
          scrollToError(this.errors)
          this.setSaving(true)
        }
      }
    },
    checkCatalogProduct(model) {
      if (model.catalogProductType !== CATALOG_PRODUCT_TYPES.MANUAL) {
        model.catalogProducts = []
        this.catalogSet.adGroupId = model.adGroupId
        this.catalogSet.formatId = PRODUCT_NATIVE_AD_FORMAT
        this.catalogSet.catalogSetId = model.catalogSetId != null ? model.catalogSetId : 0
      }
    },
    setNativeType() {
      if (this.model.adGroup.adSubtypeId !== PRODUCT_NATIVE_AD_SUBTYPE || this.model.catalogs.length === 0) this.type = this.endpointType.MANUAL
      else if (this.model.adGroup.adSubtypeId === PRODUCT_NATIVE_AD_SUBTYPE && this.adId > 0) {
        this.type = this.endpointType.MANUAL
      }
    },
    cancelAd() {
      this.$router.push(`/${this.$route.params.accountId}`)
      // this.$router.push(`/${this.$route.params.accountId}/ad/create`)
    },
    async showPreview(show) {
      if (!show) {
        // If its a catalog product or catalog set, dont validate url since its always {{product_url}}
        if (this.model.nativeAdModel.catalogItemId == null && this.model.nativeAdModel.catalogSetId == null) {
          try {
            const response = await AdsService.sanitazeUrl(this.model.nativeAdModel.url)
            this.model.nativeAdModel.url = response
          } catch (error) {
            this.error(error.message)
          }
        }

        this.preview = true
        let preview = this.model.nativeAdModel.htmlContent
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.model.nativeAdModel.customProperties.length; i++) {
          const prop = this.model.nativeAdModel.customProperties[i]
          let propValue = prop.value
          if (propValue == null || !propValue.length) propValue = prop.displayName
          preview = preview.split(`{{${prop.name}}}`).join(propValue)
        }
        if (this.$refs.previewFrameDesktop) {
          this.$refs.previewFrameDesktop.srcdoc = preview
          this.$refs.previewFrameMobile.srcdoc = `<div class="mobile">${preview}</div>`
        }
      } else {
        this.preview = false
      }
    },
    checkFileThumbnail(index) {
      this.dropzoneIndex = index
      this.setSaving(true)
    },
    uploadFile(file, response) {
      if (response.count && response.results.length) {
        this.model.nativeAdModel.customProperties[this.dropzoneIndex].value = response.results[0].imageLink
        this.uploadMessage = response.message
        this.success(response.message)
      }
      this.setSaving(false)
    },
    removeFile(file, index) {
      this.$refs[`nativeAdDropzone-${index}`][0].removeFile(file)
    },
    initializeNativeCustomProperties() {
      const customProperties = this.model.nativeAdModel.customProperties.filter(x => x.inputType === 2)
      customProperties.forEach(item => {
        this.name = item.name
      })

      let preview = this.model.nativeAdModel.htmlContent
      // const imageUrl = customProperties[0]
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.model.nativeAdModel.customProperties.length; i++) {
        const prop = this.model.nativeAdModel.customProperties[i]
        let propValue = prop.value
        if (propValue == null || !propValue.length) propValue = prop.displayName
        preview = preview.split(`{{${prop.name}}}`).join(propValue)
      }
      if (this.$refs.previewFrameDesktop) {
        this.$refs.previewFrameDesktop.srcdoc = preview
        this.$refs.previewFrameMobile.srcdoc = `<div class="mobile">${preview}</div>`
      }
    },
    openItemModal(catalog) {
      this.catalogModel = {
        encodedId: catalog.encodedId,
        catalogType: catalog.catalogType,
        items: [],
        page: 0,
        loading: true,
        filter: {
          name: '',
          brands: [],
          categories: [],
        },
      }
      this.loadedAllItems = false
      this.model.nativeAdModel.catalogSetId = null
      this.$set(this.model.nativeAdModel, 'catalogProductType', 1)
      this.$refs['catalog-item-modal'].show()
      this.loadItems()
    },
    async loadItems() {
      if (this.searchingCatalogItems || this.loadedAllItems) return

      this.catalogModel.loading = true
      this.searchingCatalogItems = true
      const filter = {
        catalogId: this.catalogModel.encodedId,
        page: this.catalogModel.page,
        name: this.catalogModel.filter.name,
        brands: this.catalogModel.filter.brands,
        categories: this.catalogModel.filter.categories,
      }
      try {
        const response = await CatalogsService.getCatalogItemDetails(this.catalogModel.encodedId, filter, this.$route.params.accountId)
        const existingItems = this.catalogModel.items
        const itemsFromSearch = response.filter(x => existingItems.findIndex(y => y.catalogItemId === x.catalogItemId) < 0)
        this.catalogModel.items.push(...itemsFromSearch)
        if (response.length === 0) this.loadedAllItems = true
      } catch (error) {
        this.error(error)
      } finally {
        this.catalogModel.loading = false
        this.catalogModel.page += 1
        this.searchingCatalogItems = false
      }
    },
    filterItemsByName: debounce(function () {
      if (this.catalogModel.filter.name.length === 1) { return }
      this.filterItems()
    }, 500),
    filterItems() {
      this.catalogModel.page = 0
      this.loadedAllItems = false
      this.catalogModel.items = this.catalogModel.items.filter(x => x.selected)
      this.loadItems()
    },
    clearCustomProperties() {
      // eslint-disable-next-line no-return-assign
      this.model.nativeAdModel.customProperties.forEach(x => x.value = '')
      this.model.nativeAdModel.url = ''
    },
    getCamelCaseFromPascalCase(str) {
      return str.charAt(0).toLowerCase() + str.substring(1)
    },
    getStringFromHtml(str, maxLength) {
      if (!str) return str

      const sanitized = str.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ')

      return maxLength === 0 ? sanitized : sanitized.substring(0, maxLength)
    },
    selectCatalogProduct(catalogProduct) {
      this.$set(catalogProduct, 'selected', !catalogProduct.selected)
    },
    addCatalogProducts() {
      if (!Object.prototype.hasOwnProperty.call(this.model, 'catalogProducts')) {
        this.$set(this.model, 'catalogProducts', [])
      }
      const selectedCatalogProducts = this.catalogModel.items.filter(x => x.selected)
      this.$refs['catalog-item-modal'].hide()
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selectedCatalogProducts.length; i++) {
        const catalogProduct = selectedCatalogProducts[i]
        const existsCatalogProduct = this.model.catalogProducts.filter(x => x.catalogItemId === catalogProduct.catalogItemId)
        // eslint-disable-next-line no-continue
        if (existsCatalogProduct.length !== 0) { continue }

        const nativeAdModel = {
          adGroupId: this.model.adGroup.id,
          adId: 0,
          formatId: PRODUCT_NATIVE_AD_FORMAT,
          catalogItemId: catalogProduct.catalogItemId,
          imageUrl: catalogProduct.imageUrl,
          errors: {},
          url: '{{product_url}}',
          impressionTag: '',
          name: `${catalogProduct.contentId} - ${catalogProduct.title}`,
        }
        this.model.catalogProducts.push(nativeAdModel)
      }
    },
    hideGallery() {
      this.$refs['catalog-item-modal'].hide()
    },
    removeCatalogProductAd(index) {
      this.model.catalogProducts.splice(index, 1)
    },
    async loadBrands(name) {
      if (this.loadingMultiselect || name.length < 2) return

      this.loadingMultiselect = true
      try {
        const response = await CatalogsService.searchCatalogBrands(this.catalogModel.encodedId, name, this.$route.params.accountId)
        this.brands = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
      }
    },
    async loadCategories(name) {
      if (this.loadingMultiselect || name.length < 2) return

      this.loadingMultiselect = true
      try {
        const response = await CatalogsService.searchCatalogCategories(this.catalogModel.encodedId, name, this.$route.params.accountId)
        this.categories = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
      }
    },
    getProductImage() {
      // The reason why we're concatenating math random to image url is cause of chrome browser cache image. Image dissappears on Chrome after clicking preview few times.
      // The bug doesn't happen on other browsers, tested it on Firefox
      if (this.productInfo.imageUrl) return `${this.productInfo.imageUrl}?${Math.random()}`

      const imageUrl = this.model.nativeAdModel.customProperties.find(x => x.inputType === 2)
      if (imageUrl) this.productInfo.imageUrl = imageUrl.value
      return this.productInfo.imageUrl
    },
    setCatalogProduct(catalog) {
      this.$set(this.model, 'selectedCatalog', catalog)
      this.loadCatalogSets()
    },
    setCatalogProductType(type) {
      this.$set(this.model, 'catalogProducts', [])
      this.$set(this.model.nativeAdModel, 'catalogProductType', type)
    },
    async loadCatalogSets(catalogSetIdSelected = 0) {
      try {
        const response = await CatalogSetsService.getCatalogSets(this.selectedCatalog.encodedId, this.$route.params.accountId)
        this.catalogSets = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
        if (catalogSetIdSelected !== 0) this.selectedCatalogSet()
      }
    },
    resetCatalogType() {
      this.$set(this.model.nativeAdModel, 'catalogProductType', 0)
      // to hide adname field
      this.$set(this.model.nativeAdModel, 'catalogSetId', null)
      this.loadCatalogSets()
    },
    redirectToCatalogSetCreate(selectedCatalog) {
      const { accountId } = this.$route.params
      const { adGroupId } = this.$route.query
      return `/${accountId}/catalogs/${selectedCatalog.encodedId}/sets/create?adGroupId=${adGroupId}`
    },
    selectedCatalogSet() {
      this.model.catalogProducts = []
      const catalogSet = this.catalogSets.find(x => x.id === this.model.nativeAdModel.catalogSetId)
      if (catalogSet) {
        const catalogSetModel = {
          adGroupId: this.model.adGroupId,
          adId: 0,
          formatId: PRODUCT_NATIVE_AD_FORMAT,
          catalogSetId: this.model.catalogSetId,
          name: `${catalogSet.name} - ${catalogSet.encodedId}`,
          errors: {},
          imageUrl: '{{image_url}}',
          url: '{{product_url}}',
          impressionTag: '',
          itemsCount: 0,
        }
        this.catalogSet = catalogSetModel
      }
      this.loadCatalogSetItemsCount()
    },
    async loadCatalogSetItemsCount() {
      this.loadingCatalogSetItemsCount = true
      try {
        const response = await CatalogSetsService.getCatalogSetItemsCount(this.selectedCatalog.encodedId, this.model.nativeAdModel.catalogSetId, this.$route.params.accountId)
        this.catalogSet.itemsCount = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingCatalogSetItemsCount = false
      }
    },
    isSaveButtonDisabled() {
      if (this.type === 0 && this.adId === 0) return true

      if (this.saving) return true

      if (this.loadingCatalogSetItemsCount) return true

      if (this.type === this.endpointType.MANUAL) {
        return false
      }
      if (this.type === this.endpointType.CATALOG_PRODUCT) {
        if (!this.selectedCatalog) return true

        if (this.model.nativeAdModel.catalogProductType === 0) return true

        if (this.model.nativeAdModel.catalogProductType === CATALOG_PRODUCT_TYPES.MANUAL && (!this.model.catalogProducts || this.model.catalogProducts.length === 0)) return true

        if (this.model.nativeAdModel.catalogProductType === CATALOG_PRODUCT_TYPES.SET && this.model.nativeAdModel.catalogSetId <= 0) return true
      }
      return false
    },
    canAccountCreateSet(selectedCatalogAccountId) {
      return selectedCatalogAccountId === this.$route.params.accountId
    },
    autoCompleteNativeAdModel() {
      if (this.model.selectedCatalog == null) return

      this.$set(this, 'selectedCatalog', this.model.selectedCatalog)
      this.$set(this, 'type', 2)
      this.setCatalogProductType(2)
      this.loadCatalogSets(this.model.nativeAdModel.catalogSetId)
    },
    resetToManualProduct(type) {
      this.type = type
      this.model.nativeAdModel.catalogSetId = null
      this.model.nativeAdModel.catalogProductType = 0
    },
  },
}

</script>

<style lang="scss">
@import '@/assets/scss/views/client/ads-manager/create/ads/native-ad.scss';
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
